// extracted by mini-css-extract-plugin
var _1 = "UpgradeButton-module__boltIcon--ffmWW";
var _2 = "UpgradeButton-module__upgradeButton--Cq0Lv";
var _3 = "UpgradeButton-module__upgradeButtonContainer--MX34R";
export { _1 as "boltIcon", _2 as "upgradeButton", _3 as "upgradeButtonContainer" }
